import utils from '../../../../modules/utils';
import API from '../../../api/api';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';

function isTokenReceived(status) {
  return status === 'OPTTY_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'OPTTY';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams = '') {
  const hash = utils.fn.getURIParam(queryParams, 'hash') || '';
  const reference = utils.fn.getURIParam(queryParams, 'reference') || '';
  const status = utils.fn.getURIParam(queryParams, 'status') || '';
  const providerReference = utils.fn.getURIParam(queryParams, 'providerReference') || '';
  
  try {
    doMetric('OpttyProcessor', [{name: 'status', value: status}], [], 'impression');
  } catch (error) {
    Track.track(error);
  }
  
  if (status.toUpperCase() === 'SUCCESSFUL' || status.toUpperCase() === 'PENDING') {
    return API.doAPIRequest(`/v2/return-from-hosted/optty?hash=${hash}&reference=${reference}&status=${status}&providerReference=${providerReference}`);
  }
  
  return Promise.reject();
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};